import { PRODUCT_LANGUAGE_COOKIE } from "@/lib/product-language";

export const LOCALE_PREFERENCES_STORAGE_KEY = "prvbuy:locale-preferences";
export const LOCALE_PREFERENCES_CHANGE_EVENT = "prvbuy:locale-preferences-change";

export type LocalePreferences = {
  language: string;
  currency: string;
};

export const defaultLocalePreferences: LocalePreferences = {
  language: "EN",
  currency: "USD",
};

export function readLocalePreferences(): LocalePreferences {
  if (typeof window === "undefined") return defaultLocalePreferences;

  try {
    const stored = JSON.parse(window.localStorage.getItem(LOCALE_PREFERENCES_STORAGE_KEY) ?? "");
    return {
      language: typeof stored?.language === "string" ? stored.language : defaultLocalePreferences.language,
      currency: typeof stored?.currency === "string" ? stored.currency : defaultLocalePreferences.currency,
    };
  } catch {
    return defaultLocalePreferences;
  }
}

export function saveLocalePreferences(preferences: LocalePreferences) {
  if (typeof window === "undefined") return;
  window.localStorage.setItem(LOCALE_PREFERENCES_STORAGE_KEY, JSON.stringify(preferences));
  document.cookie = `${PRODUCT_LANGUAGE_COOKIE}=${encodeURIComponent(preferences.language)}; Path=/; Max-Age=31536000; SameSite=Lax`;
  window.dispatchEvent(new CustomEvent(LOCALE_PREFERENCES_CHANGE_EVENT, { detail: preferences }));
}
